import * as Hooks from 'hooks'
import { Loading } from './text'

export default function ClientOnly({ children, fallback = <Loading /> }) {
    const mounted = Hooks.useMounted()

    return mounted ? children : fallback
}
